import Scroll from './../components/scroll';
import Tools from './../components/tools';
import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';

export default class Oeuvre {
    constructor() {
        // Oeuvre
        this.SLIDER;

        Scroll.init();
        this.mobileSlider();
        this.displayImages();
        this.displayPopin();
        this.scrollToSection();
        this.closeMobileSlider();

        window.addEventListener('resize', () => {
            if (window.innerWidth > 1023) {
                this.cleanSlider();
            }
        });
    }

    displayImages() {
        const articles = document.querySelectorAll('.article.listing');
        if (articles.length > 0) {
            articles.forEach((article) => {
                article.querySelectorAll('.listing__cat .item').forEach((item) => {
                    item.addEventListener('click', () => {
                        if (window.innerWidth > 1024) {
                            this.desktopImages(article, item);
                        } else {
                            this.mobileImages(item);
                        }
                    });
                });
            });
        }
    }

    desktopImages(article, item) {
        if (article.querySelector('.item.js-active') && article.querySelector('.item.js-active') !== item) {
            article.querySelector('.item.js-active').classList.remove('js-active');

            article.querySelector('.listing__figure').classList.add('js-transition');
            setTimeout(() => {
                article.querySelector('.listing__image').src = item.dataset.img;
                article.querySelector('.listing__image').srcset = `${item.dataset.img} 1x, ${item.dataset.imgsrcset} 2x`;
                article.querySelector('.listing__figure').classList.remove('js-transition');
            }, 400);
        }
        item.classList.add('js-active');
    }

    mobileImages(item) {
        document.querySelector('.tns-outer').classList.add('js-visible');
        document.querySelector('.nav').classList.add('js-sliderOpen');
        document.querySelector('.images__sliderClose').classList.add('js-visible');

        const offset = window.pageYOffset;
        setTimeout(() => {
            document.body.classList.add('js-fixed');
            document.body.style.top = `-${offset}px`;
        }, 450);

        const index = item.parentElement.parentElement.parentElement.dataset.index;
        let slideToGo = 0;
        const nodes = Array.prototype.slice.call( item.parentElement.children );
        if (parseInt(index) !== 1) {
            slideToGo = nodes.indexOf( item );
            for(let i = parseInt(index); i > -1;) {
                i -= 1;
                if (document.querySelector(`.listing[data-index="${i}"]`)) {
                    slideToGo += document.querySelectorAll(`.listing[data-index="${i}"] .listing__cat .item`).length;
                }
            }
        } else {
            slideToGo = nodes.indexOf( item );
        }
        this.SLIDER.goTo( slideToGo );
    }

    cleanSlider() {
        const scrollY = document.body.style.top;
        document.body.classList.remove('js-fixed');
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);

        document.querySelector('.tns-outer').classList.remove('js-visible');
        document.querySelector('.nav').classList.remove('js-sliderOpen');
        document.querySelector('.images__sliderClose').classList.remove('js-visible');
    }

    mobileSlider() {
        const slider = document.querySelector('.images__slider');
        if (slider) {
            this.SLIDER = tns({
                container: slider,
                items: 1,
                slideBy: 'page',
                loop: false,
                autoplay: false,
                nav: false,
                speed: 650,
                controlsPosition: 'bottom',
                controlsText: ['<span class="sr-only">Précédent</span><svg xmlns="http://www.w3.org/2000/svg" width="10.339" height="10.339" viewBox="0 0 10.339 10.339"><g><path d="M14.556 10.122a.482.482 0 0 1 .678 0l2.371 2.378a.479.479 0 0 1 .015.661l-2.336 2.344a.479.479 0 1 1-.678-.676l1.986-2.016-2.036-2.013a.474.474 0 0 1 0-.678z" transform="translate(-10.512 -7.647)" fill="currentColor"/><path d="M3.375 8.544a5.169 5.169 0 1 0 5.169-5.169 5.169 5.169 0 0 0-5.169 5.169zm.8 0a4.378 4.378 0 1 1 1.282 3.092A4.337 4.337 0 0 1 4.17 8.544z" fill="currentColor" transform="translate(-3.375 -3.375)"/></g></svg>', '<span class="sr-only">Suivant</span><svg xmlns="http://www.w3.org/2000/svg" width="10.339" height="10.339" viewBox="0 0 10.339 10.339"><g><path d="M14.556 10.122a.482.482 0 0 1 .678 0l2.371 2.378a.479.479 0 0 1 .015.661l-2.336 2.344a.479.479 0 1 1-.678-.676l1.986-2.016-2.036-2.013a.474.474 0 0 1 0-.678z" transform="translate(-10.512 -7.647)" fill="currentColor"/><path d="M3.375 8.544a5.169 5.169 0 1 0 5.169-5.169 5.169 5.169 0 0 0-5.169 5.169zm.8 0a4.378 4.378 0 1 1 1.282 3.092A4.337 4.337 0 0 1 4.17 8.544z" fill="currentColor" transform="translate(-3.375 -3.375)"/></g></svg>'],
            });
        }
    }

    closeMobileSlider() {
        const btn = document.querySelector('.images__sliderClose');
        if (btn) {
            btn.addEventListener('click', () => {
                this.cleanSlider();
            });
        }
    }

    displayPopin() {
        const popin = document.querySelector('.popin');
        const zoomBtns = document.querySelectorAll('.listing__zoom');
        if (popin && zoomBtns.length > 0) {
            popin.querySelector('.popin__close').addEventListener('click', () => {
                popin.classList.remove('js-visible');

                const scrollY = document.body.style.top;
                document.body.classList.remove('js-fixed');
                document.body.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            });

            zoomBtns.forEach((btn) => {
                btn.addEventListener('click', () => {
                    popin.querySelector('.popin__image').src = btn.nextElementSibling.src;
                    popin.querySelector('.popin__image').srcset = btn.nextElementSibling.srcset;
                    popin.classList.add('js-visible');

                    const offset = window.pageYOffset;
                    setTimeout(() => {
                        document.body.classList.add('js-fixed');
                        document.body.style.top = `-${offset}px`;
                    }, 450);
                });
            });
        }
    }

    scrollToSection() {
        if (window.location.search !== '') {
            const params = (new URL(document.location)).searchParams;
            window.scrollTo({
                top: Tools.offset( document.querySelector(`.listing[data-tab="${params.get('tab')}"]`) ).top,
                left: 0,
                behavior: 'smooth',
            });
        }
    }
}